/**
 * /operations/leaves-agent — Tashghil leave operations agent
 * (Pack 7 v2).
 */
import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function LeavesAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Leaves Agent"
        subtitle="Tashghil drives leave requests + accruals + carry-over. Mutaba'aa watches Articles 109 / 117 / 152. Khidmat handles intake."
      />
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="tashghil" /><h3 className="text-base font-semibold">Tashghil — ops</h3>
        </div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li>Auto-approve leave within scope per autonomy mode</li>
          <li>Annual leave accrual + carry-over computation</li>
          <li>Sick leave tier classification (Article 117)</li>
          <li>Maternity / paternity / Hajj / bereavement workflows</li>
        </ul>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="mutabaa" /><h3 className="text-base font-semibold">Mutaba'aa — statutory floors</h3>
        </div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li><strong>Article 75</strong> — notice period; leave taken during notice</li>
          <li><strong>Article 109</strong> — 21/30 day annual leave floor</li>
          <li><strong>Article 117</strong> — sick tier breakdown 30/60/30</li>
          <li><strong>Article 152</strong> — no termination during maternity window</li>
        </ul>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="khidmat" /><h3 className="text-base font-semibold">Khidmat — employee intake</h3>
        </div>
        <p className="text-sm text-text-secondary">Employee leave requests flow through Khidmat (WhatsApp / Teams / chat) and delegate to Tashghil for approval routing.</p>
      </section>
    </div>
  );
}
